import { useElement } from './core/element.js';
import { mediaQueryList } from './core/utils/mediaQuery.js';
const name = 's-drawer';
const props = {};
const style = `:host{display:flex;height:100%;overflow:hidden;position:relative}.start,.end{flex-shrink:0;height:100%;display:none;overflow:hidden}.start{order:-1}.scrim{position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;display:none;pointer-events:none;transition:opacity .3s ease-out;background:color-mix(in srgb,var(--s-color-scrim, #000000) 70%,transparent)}.view{display:flex;flex-direction:column;flex-grow:1;min-width:0;height:100%;position:relative}::slotted([slot=start]),::slotted([slot=end]){width:280px;border-width:1px;height:100%;box-sizing:border-box;pointer-events:auto;position:relative;background:var(--s-color-surface-container-high, #f2f4f5);border-color:var(--s-color-surface-variant, #dbe4e7)}::slotted([slot=start]){border-right-style:solid}::slotted([slot=end]){border-left-style:solid}::slotted(s-scroll-view:not([slot])){flex-grow:1}@media (min-width: 1024px){.start.show,.end.show{display:block}}@media (max-width: 1024px){.scrim{display:block;z-index:1}.scrim.show-laptop{opacity:1;pointer-events:auto}.start,.end{position:absolute;z-index:1;max-width:75%;display:none}.end{left:auto;right:0}.start.show-laptop,.end.show-laptop{display:block}::slotted([slot=start]),::slotted([slot=end]){border-right-style:none;box-shadow:var(--s-elevation-level-3, 0 5px 5px -3px rgba(0, 0, 0, .2), 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 2px rgba(0, 0, 0, .12))}}`;
const template = `<slot class="view" part="view"></slot><div class="scrim" part="scrim show"></div><slot name="start" class="start show" part="start"></slot><slot name="end" class="end show" part="end"></slot>`;
export class Drawer extends useElement({
    style, template, props,
    setup(shadowRoot) {
        const scrim = shadowRoot.querySelector('.scrim');
        const slots = {
            start: shadowRoot.querySelector('.start'),
            end: shadowRoot.querySelector('.end')
        };
        const getElement = (name = 'start') => slots[name];
        const getClassName = (folded) => folded ?? mediaQueryList.laptop.matches ? 'show-laptop' : 'show';
        const getOffset = (name = 'start') => ({ start: -1, end: 1 }[name]);
        const animateOptions = { duration: 300, easing: 'ease-out' };
        const show = (slot, folded) => {
            const element = getElement(slot);
            const className = getClassName(folded);
            if (element.classList.contains(className))
                return;
            const offset = getOffset(slot);
            element.classList.add(className);
            const keyframe = mediaQueryList.laptop.matches ? [{ transform: `translateX(${element.offsetWidth * offset}px)` }, { transform: `translateX(0)` }] : [{ width: 0 }, { width: element.offsetWidth + 'px' }];
            scrim.classList.add(className);
            element.animate(keyframe, animateOptions);
        };
        const close = (slot, folded) => {
            const element = getElement(slot);
            const className = getClassName(folded);
            if (!element.classList.contains(className))
                return;
            const offset = getOffset(slot);
            const keyframe = mediaQueryList.laptop.matches ? [{ transform: `translateX(0)`, display: 'block' }, { transform: `translateX(${element.offsetWidth * offset}px)`, display: 'block' }] : [{ width: element.offsetWidth + 'px', display: 'block' }, { width: 0, display: 'block' }];
            element.animate(keyframe, animateOptions);
            element.classList.remove(className);
            scrim.classList.remove(className);
        };
        const toggle = (slot, folded) => {
            const element = getElement(slot);
            const className = getClassName(folded);
            element.classList.contains(className) ? close(slot, folded) : show(slot, folded);
        };
        scrim.addEventListener('pointerdown', () => {
            close('start', true);
            close('end', true);
        });
        return {
            expose: { show, close, toggle }
        };
    }
}) {
}
Drawer.define(name);
